var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "121px",
    height: "90px",
    viewBox: "0 0 121 90",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Illustration") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Journey-4---Inbox",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "6.3--can't-find-data--confirmation-message",
    transform: "translate(-905.000000, -294.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Inbox",
    transform: "translate(489.000000, 97.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(336.000000, 197.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Illustration",
    transform: "translate(81.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "stamp-document",
    transform: "translate(0.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115,55.2212389 C115,24.7239292 90.375125,0 60,0 C29.624875,0 5,24.7239292 5,55.2212389 C5,63.3470442 6.76275,71.0545487 9.9005,78 L110.0995,78 C113.23725,71.0545487 115,63.3470442 115,55.2212389",
    id: "Fill-1",
    fill: "#F4F6FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,78 L3,78",
    id: "Stroke-5",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116,78 L119,78",
    id: "Stroke-7",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,78 L113,78",
    id: "Stroke-3",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(28.000000, 11.000000)",
    stroke: "#7450C8",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64,6.08780102 C64,2.72469448 61.2720283,0 57.9048768,0 L6.09512324,0 C2.73038366,0 0,2.72469448 0,6.08780102 L0,53.2700657 C0,56.6307632 2.72797166,59.3578667 6.09512324,59.3578667 L17.2771538,59.3578667 C18.6761137,59.3578667 19.8097535,60.4901447 19.8097535,61.887424 L19.8097535,68.4715 C19.8097535,69.4929593 20.4272254,70.4156454 21.3727293,70.808329 C22.3206452,71.1986036 23.4084571,70.9817844 24.132057,70.2590538 L34.3058717,60.0974611 C34.7810357,59.6252771 35.4250396,59.3578667 36.0955755,59.3578667 L57.9048768,59.3578667 C61.2720283,59.3578667 64,56.6307632 64,53.2700657 L64,6.08780102 Z",
    id: "Stroke-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.4334215,17 L11.5641534,17 C10.9627425,17 10.4365079,17.2225865 10,17.5441004 L29.3785273,28.3271816 C30.9911817,29.2242728 33.0063933,29.2242728 34.6190476,28.3271816 L54,17.5441004 C53.5634921,17.2203382 53.0348325,17 52.4334215,17 Z",
    id: "Stroke-94",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5729436,44 L11.4270564,44 C10.0873213,44 9,42.9363349 9,41.6257474 L9,19.3742526 C9,18.0636651 10.0873213,17 11.4270564,17 L52.5729436,17 C53.9126787,17 55,18.0636651 55,19.3742526 L55,41.6257474 C55,42.9363349 53.9126787,44 52.5729436,44 Z",
    id: "Stroke-95",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "check-circle",
    transform: "translate(81.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#7450C8",
    cx: 11,
    cy: 11,
    r: 11
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.20281695,12.2237634 L7.4109082,10.3719367 C7.14549949,10.0516535 6.72876829,9.91214277 6.33204993,10.010763 C5.93533157,10.1093832 5.62558246,10.4294897 5.53015321,10.8394736 C5.43472396,11.2494574 5.5697207,11.6801233 5.87964073,11.9544068 L8.43175318,14.6030801 C8.63670284,14.8131631 8.9141535,14.9302774 9.20281695,14.9285526 C9.48771945,14.9273129 9.76074062,14.810422 9.96302066,14.6030801 L15.3930472,8.99148407 C15.5986417,8.78075 15.7142857,8.49388986 15.7142857,8.19463743 C15.7142857,7.895385 15.5986417,7.60852486 15.3930472,7.3977908 C14.9694644,6.96264116 14.2853624,6.96264116 13.8617797,7.3977908 L9.20281695,12.2237634 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustration);
export default __webpack_public_path__ + "static/media/Illustration.626444392e62a92d75434f16092e6175.svg";
export { ForwardRef as ReactComponent };